/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GescalesDockUpsert } from '../../models/gescales-dock-upsert';

export interface UpsertGescalesDock$Params {
  
    /**
     * The Gescales dock upsert body
     */
    body: GescalesDockUpsert
}

export function upsertGescalesDock(http: HttpClient, rootUrl: string, params: UpsertGescalesDock$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, upsertGescalesDock.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

upsertGescalesDock.PATH = '/custom/dock-occupancy/gescales/dock/upsert';
